
const url = {
    //Local
    //localBack : 'http://localhost:3368/',
    //localFront: 'http://localhost:44397/',
    //cas: 'https://auth.test.espol.edu.ec',
    //Pruebas Diego
    //localBack : 'http://200.10.147.25/',
    //localFront : 'http://200.10.147.25/',
    //Procuccion
    localBack: 'https://wsespolads.espol.edu.ec/',
    localFront: 'https://espolads.espol.edu.ec/',
    cas: 'https://auth.espol.edu.ec',
    //serverpruebas
    //localBack: 'http://192.168.253.6:8082/',
    //localFront:'http://192.168.253.7:8089/',
    //cas: 'https://auth.test.espol.edu.ec',

    //espolads.espol.edu.ec / debe apuntar a 200.10.147.12
    //wsespolads.espol.edu.ec / debe apuntar a 200.10.147.13
}

export default url;
